import React, { Component } from "react";
import { apiFetch } from "apiFetch";
import ApplicationLayout from "../../shared/components/application-layout";
import {connect} from 'react-redux';
import IdleTimer from "react-idle-timer";
import { toast } from "react-toastify";

const IDLE_TIMEOUT = 900000;


const initialState = {
  visibility: {},
  selectedBankAccount: { sourceId: null },
  ach_verified: [],
  justVerifiedAccount: null
};

class Application extends Component {
  constructor(props) {
    super(props);
  }

  state = initialState;

  resetState = () => {
    this.setState({...initialState});
  };

  componentDidMount() {
    toast.dismiss();

    apiFetch("/api/me", { method: "GET" })
      .then(data => {
        const {user} = data;
        this.setState({
          user
        });
      })
      .catch((e) => {
        console.log(e);
        if (e !== 'Unauthorized') {
          toast.error('An error occured, please try again.');
        }
      });
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  handleVerifyAccount = (values) => {
    const params = Object.keys(values).reduce((p, key) => {
      p[key] = parseInt(values[key], 10);
      return p;
    }, {});

    const {sourceId, customerId} = this.state.selectedBankAccount;

    if (!sourceId) {
      toast.error("Please, select one bank account.");
      return null;
    }

    params.customerId = customerId;
    params.sourceId = sourceId;

    apiFetch("/api/user/bank_verification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params),
      rawResponse: true
    })
    .then((resp) => {
      if (resp.ok) {
        this.handleShow("NotificationMessage", false);
        return this.setState({justVerifiedAccount: sourceId}, () => {
          toast.success("Your bank account was successfully verified.");
        })
      }
      return toast.error("An error occured, please try again.");
    })
  };

  selectBankAccount = method => {
    this.setState({
      selectedBankAccount: method
    });
  };

  handleShow = (component, show, options) => {
    this.setState({
      visibility: {
        [component]: show
      },
      [component]: options
    });

    if (!show) {
      this.props.loadHomeData();
    }
  };

  handleIdle = () => {
    apiFetch("/api/oauth2/access_token", {
      method: "DELETE"
    }).then(() => {
      this.props.dispatch({
        type: 'AUTH_SIGNOUT_SUCCESS',
      });
      toast.error("You have been logged out due to inactivity");
    });
  };

  handleUpdateAch = bankAccount => {
    toast.dismiss();

    this.setState({
      ach_verified: [...(this.state.ach_verified || []), bankAccount]
    });

  };

  closeAchVerification = () => {
    this.handleShow("NotificationMessage", false);
  };

  showVerificationDialog = (accounts) => {
    this.handleShow("NotificationMessage", true, {
      bank_accounts: accounts
    })
  }


  afterLogout = () => {
    this.resetState();
    toast.dismiss();
  };

  render() {
    return (
      <IdleTimer
        ref="idleTimer"
        idleAction={this.handleIdle}
        timeout={IDLE_TIMEOUT}
        startOnLoad={false}
      >
        <ApplicationLayout
          {...this.state}
          {...this.props}
          handleShow={this.handleShow}
          afterLogout={this.afterLogout}
          handleVerifyAccount={this.handleVerifyAccount}
          showVerificationDialog={this.showVerificationDialog}
          setBankAccount={this.setBankAccount}
          selectBankAccount={this.selectBankAccount}
          handleUpdateAch={this.handleUpdateAch}
          closeAchVerification={this.closeAchVerification}
        />
      </IdleTimer>
    );
  }
}

export default connect()(Application);



// WEBPACK FOOTER //
// ./src/shared/containers/application.js